import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CompanyInterceptorService implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const companyId = 4; //NICOLAS 19-08-2025 => OJO SOLO CAMBIAR POR FRONT NUEVO
    let request = req;

    if (companyId) {
      request = req.clone({
        setHeaders: {
          'X-Company': `${companyId}`
        }
      });
    }

    return next.handle(request);
  }

}
